import { ANTI_BOT_PROVIDERS, AntiBotProviderType } from "../../../constants/antiBot";
import { AntiBotClientStrategy } from "./types";
import { recaptchaV3Strategy } from "./recaptchaV3";

export const ANTI_BOT_CLIENT_STRATEGIES: Record<
  AntiBotProviderType,
  AntiBotClientStrategy
> = {
  [ANTI_BOT_PROVIDERS.RECAPTCHA_V3]: recaptchaV3Strategy,
};

export const resolveAntiBotStrategy = (
  provider?: string | null,
): AntiBotClientStrategy | null => {
  if (!provider) {
    return null;
  }

  return (
    (ANTI_BOT_CLIENT_STRATEGIES as Record<string, AntiBotClientStrategy>)[
      provider
    ] ?? null
  );
};

export type { AntiBotClientStrategy } from "./types";
